export default "__VITE_ASSET__BA6y$K05__"